import * as React from "react";
import { SVGProps } from "react";
const SvgLandline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m20.526 13-.63-2.139L23.421 13h-2.896.001ZM16 16.58 13.695 15h4.61L16 16.58Zm7.032 11.991-5.058-2.968 3.566-2.093 1.492 5.061Zm-5.264-10.779 1.736-1.189.878 2.982-2.614-1.793Zm-6.042 4.143L16 19.005l4.272 2.93L16 24.443l-4.274-2.508Zm-2.759 6.636 1.493-5.061 3.564 2.093-5.057 2.968Zm3.53-11.968 1.734 1.189-2.614 1.792.88-2.981ZM8.576 13l3.527-2.14-.63 2.14H8.576ZM16 4.718l.815 2.766h-1.63L16 4.718Zm-1.406 4.766h2.811L18.441 13h-4.883l1.036-3.516Zm12.924 3.661-8.462-5.133L16.96.898a1 1 0 0 0-1.918 0l-2.098 7.114-8.462 5.133A1 1 0 0 0 5 15h5.883l-1.97 6.689a.417.417 0 0 0-.018.057l-2.56 8.685A1 1 0 0 0 7.8 31.576l8.2-4.813 8.2 4.813a.996.996 0 0 0 1.458-.557 1 1 0 0 0 .007-.588L21.116 15H27a1 1 0 0 0 .518-1.855Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLandline;
